import { Radio as MuiRadio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const Radio = ({ isChecked }) => {
  const useStyles = makeStyles(() => ({
    root: {
      '&.MuiRadio-colorSecondary.Mui-checked': {
        color: 'inherit',
      },
      '&.MuiIconButton-colorSecondary:hover': {
        backgroundColor: 'inherit',
      },
    },
  }));
  const classes = useStyles();
  return (
    <div className="text-theme">
      <MuiRadio
        className="flex items-center justify-center"
        classes={classes}
        checked={isChecked}
      />
    </div>
  );
};

Radio.propTypes = {
  isChecked: PropTypes.bool,
};

Radio.defaultProps = {
  isChecked: false,
};

export default Radio;
